import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import { useState } from 'react';
import Modal from '../../Modal/Modal';
import ModalFooter from '../../ModalFooter/ModalFooter';
import ModalHeader from '../../ModalHeader/ModalHeader';

const WarningModal = ({
    children,
    onCancel, onConfirm,
    confirmButtonText
}: Props) => {
    const [state, setState] = useState({
        isLoading: false
    });

    const handleConfirm = () => {
        setState({
            ...state,
            isLoading: true
        });
        onConfirm();
    }

    const handleCancel = () => onCancel();

    return <Modal size='small'>
        <ModalHeader size='small'>
            <TitleGroup
                iconBefore={
                    <FontAwesomeIcon
                        size='lg'
                        icon={faTriangleExclamation}
                        color={'#FF9800'}
                    />
                }
            >
                <Title
                    size='medium'
                    weight='bold'
                    color='warning'
                    transform="uppercase"
                >
                    Weet je het zeker?
                </Title>
            </TitleGroup>
        </ModalHeader>
        
        <Container padding='vertical'>
            { children }
        </Container>

        <ModalFooter size='small'>
            <ButtonGroup>
                { !state.isLoading && <Button
                    size='small'
                    variant='transparent'
                    color='warning'
                    onClick={handleCancel}
                >
                    Annuleren
                </Button> }
                <Button
                    size='small' 
                    variant='solid'
                    color='warning'
                    isLoading={state.isLoading}
                    onClick={handleConfirm}
                >
                    { confirmButtonText ?? 'Doorgaan' }
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>;
}

interface Props {
    children: any,
    onCancel: any,
    onConfirm: any,
    confirmButtonText?: string
}

export default WarningModal;